'use client';

import { useEffect, useState } from 'react';
import type { Album } from '../api/album-service';

/**
 * How long an album usually takes, under a generating row. Both lines are
 * server copy (AlbumWaitEstimator); the client only switches to the overrun
 * line once the run has lasted `wait_overrun_after_seconds` since its start.
 * Apple `AlbumWaitHint` / Android `AlbumWaitHint` parity.
 */
export function AlbumWaitHint({ album }: { album: Album }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const interval = setInterval(() => setNow(Date.now()), 15_000);
    return () => clearInterval(interval);
  }, []);

  const startedAt = album.started_at ? Date.parse(album.started_at) : null;
  const isOverrun =
    startedAt !== null &&
    album.wait_overrun_after_seconds != null &&
    album.wait_overrun_hint != null &&
    now - startedAt > album.wait_overrun_after_seconds * 1000;

  return (
    <p className="text-card-meta text-muted-foreground text-balance">
      {isOverrun ? album.wait_overrun_hint : album.wait_hint}
    </p>
  );
}
